// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityValues = {
  active: "Active",
  inactive: "Inactive",
  undefinedStatus: "Undefined status",
  yes: "Yes",
  no: "No",
  global: "Global",
  loginStatusSuccess: "Success",
  loginStatusFailed: "Failed",
  loginAuthFlowPassword: "Password Login",
  loginAuthFlowOidcAuthorize: "OIDC Authorization",
  eventActionCreate: "Create",
  eventActionUpdate: "Update",
  eventActionDelete: "Delete",
  eventActionSync: "Sync",
  eventActionArchive: "Archive",
  eventActionInspect: "Inspect",
  eventActionRotate: "Rotate",
  eventActionUpdateStatus: "Update Status",
  eventActionResetPassword: "Reset Password",
  eventActionKickout: "Kick Out",
  eventActionBatchKickout: "Batch Kick Out",
  eventActionBatchUpdateStatus: "Batch Update Status",
  eventActionMove: "Move",
  eventActionSynced: "Synced",
  eventTypePlatformRoleCreated: "Platform Role Created",
  eventTypePlatformRoleUpdated: "Platform Role Updated",
  eventTypePermissionCreated: "Permission Created",
  eventTypePermissionUpdated: "Permission Updated",
  eventTypePermissionBindingUpdated: "Permission Binding Updated",
  eventTypeUserCreated: "User Created",
  eventTypeUserUpdated: "User Updated",
  eventTypeUserStatusUpdated: "User Status Updated",
  eventTypeUserPasswordReset: "User Password Reset",
  eventTypeUserKickout: "User Kicked Out",
  eventTypeUserBatchKickout: "User Batch Kicked Out",
  eventTypeUserBatchStatusUpdated: "User Batch Status Updated",
  eventTypeUserCustomFieldsUpdated: "User Custom Fields Updated",
  eventTypeCustomFieldDefinitionCreated: "Custom Field Definition Created",
  eventTypeCustomFieldDefinitionUpdated: "Custom Field Definition Updated",
  eventTypeCustomFieldDefinitionArchived: "Custom Field Definition Archived",
  eventTypeTenantCreated: "Tenant Created",
  eventTypeTenantUpdated: "Tenant Updated",
  eventTypeOrganizationCreated: "Organization Created",
  eventTypeOrganizationUpdated: "Organization Updated",
  eventTypeOrganizationMembershipCreated: "Organization Membership Created",
  eventTypeOrganizationMembershipDeleted: "Organization Membership Deleted",
  eventTypeOrganizationUnitCreated: "Organization Unit Created",
  eventTypeOrganizationUnitUpdated: "Organization Unit Updated",
  eventTypeOrganizationUnitDeleted: "Organization Unit Deleted",
  eventTypeOrganizationUnitMoved: "Organization Unit Moved",
  eventTypeApplicationCreated: "Application Created",
  eventTypeApplicationUpdated: "Application Updated",
  eventTypePlatformRoleAssignmentCreated: "Platform Role Assignment Created",
  eventTypePlatformRoleAssignmentDeleted: "Platform Role Assignment Deleted",
  eventTypeApplicationGrantCreated: "Application Access Rule Created",
  eventTypeApplicationGrantUpdated: "Application Access Rule Updated",
  eventTypeApplicationGrantDeleted: "Application Access Rule Deleted",
  eventTypePermissionBindingCreated: "Permission Binding Created",
  eventTypePermissionBindingDeleted: "Permission Binding Deleted",
  eventTypeApplicationRoleMappingCreated: "Application Role Mapping Created",
  eventTypeApplicationRoleMappingUpdated: "Application Role Mapping Updated",
  eventTypeApplicationRoleMappingDeleted: "Application Role Mapping Deleted",
  eventTypeIdentityApplicationRoleCatalogSynced: "Application Role Catalog Synced",
  eventTypeApplicationMemberSnapshotSynced: "Application Member Snapshot Synced",
  eventTypeApplicationCredentialInspected: "Application Credential Inspected",
  eventTypePortalSettingsUpdated: "Portal Settings Updated",
  eventTypeApplicationCredentialRotated: "Application Credential Rotated",
  eventTypeApplicationCredentialStatusUpdated: "Application Credential Status Updated",
  eventTypePortalGroupCreated: "Portal Group Created",
  eventTypePortalGroupUpdated: "Portal Group Updated",
  eventTypePortalGroupDeleted: "Portal Group Deleted",
  eventResourceTypePortalSettings: "Portal Settings",
  eventResourceTypePlatformRole: "Platform Role",
  eventResourceTypePermissionDefinition: "Permission Definition",
  eventResourceTypePermissionBinding: "Permission Binding",
  eventResourceTypeUser: "User",
  eventResourceTypeUserCustomFields: "User Custom Fields",
  eventResourceTypeIdentityCustomFieldDefinition: "Identity Custom Field Definition",
  eventResourceTypeTenant: "Tenant",
  eventResourceTypeOrganization: "Organization",
  eventResourceTypeOrganizationMembership: "Organization Membership",
  eventResourceTypeOrganizationUnit: "Organization Unit",
  eventResourceTypeApplication: "Application",
  eventResourceTypeApplicationGrant: "Application Access Rule",
  eventResourceTypeApplicationRoleMapping: "Application Role Mapping",
  eventResourceTypeApplicationCredential: "Application Credential",
  eventResourceTypeApplicationRoleCatalog: "Application Role Catalog",
  eventResourceTypeApplicationMemberSnapshot: "Application Member Snapshot",
  eventResourceTypePlatformRoleAssignment: "Platform Role Assignment",
  eventResourceTypePortalGroup: "Portal Group",
} as const;
